import { Component, Vue, Mixins } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import BASEAPI from '@/util/BASEAPI';
import { EmailPass } from '@/generated/api';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';

@Component({
    components: AllComponents(),
})
export default class Login extends Mixins(CommonView) {
    kurukuru: boolean = false;
    pnkzList: {name: string, path: string | null}[] = [{name: "TOP", path: "/"},{name: "ログイン", path: null}];

    public url: string = "";
    public error: string = "";

    public async created() {
        this.kurukuru = true;

        if (this.$route.query && this.$route.query.url && typeof this.$route.query.url === "string") {
            this.url = "?url=" + this.$route.query.url;
        } else {
            this.url = "/";
        }
        await this.getUserAPI();
        if (this.loginStatus != null) {
            this.$router.push(this.url);
        }

        this.kurukuru = false;
    }

    public emailPass: EmailPass = { email: "", pass: "" };

    public async login() {
        this.kurukuru = true;
        
        let login = await BASEAPI.LoginController.emailLoginUsingPOST(this.emailPass).catch(AxiosErrorHandler);
        if (isAxiosError(login)) {
            this.error = "" + login.data;
        } else {
            await this.getUserAPI();
            if (this.url !== "/") {
                this.url = this.url.substring(5);
            }
            this.$router.push(this.url);
        }
        this.kurukuru = false;
    }
}
